import React, { useState, useEffect } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import profileData from './data/profile';
import projectsData from './data/projects';
import skillsData from './data/skills';

function App() {
  const [profile, setProfile] = useState(null);
  const [projects, setProjects] = useState([]);
  const [skills, setSkills] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setProfile(profileData);
    setProjects(projectsData);
    setSkills(skillsData);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <ThemeProvider>
        <div className="min-h-screen flex items-center justify-center bg-white dark:bg-neutral-950">
          <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600"></div>
            <div className="absolute inset-0 animate-ping rounded-full h-16 w-16 border border-primary-400 opacity-20"></div>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-neutral-950">
        <Navbar />
        <main>
          <Hero profile={profile} />
          <About profile={profile} />
          <Skills skills={skills} />
          <Projects projects={projects} />
          <Contact profile={profile} />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
